export enum SubmitMode {
  ADD_TO_CART = "Add to cart",
  BUY_NOW = "Buy now",
  UPDATE_CART_ITEM = "Update cart item",
  UPDATE_BOOKING = "Update booking",
}
